<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <span style="width: 100px" :title="$t('label_snapshotSelector_snapshot')">
        <img
          :src="'/static/icons/snapshot.svg'"
          height="25"
        />
        <i style="color: #6F3996" class="bi bi-caret-down-fill"></i>
      </span>
    </template>
    <div v-for="(snapshot, index) in getSnapshots" :key="index">
      <b-dropdown-item
        @click="updateSnapshot(snapshot)"
      >
        <b v-if="currentSnapshot === snapshot">{{snapshot.date}} - {{$t(snapshot.status)}} </b>
        <div v-else>{{snapshot.date}} - {{$t(snapshot.status)}}</div>
      </b-dropdown-item>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "TemplateSnapshotSelector",
  data: function () {
    return {};
  },
  methods: {
    updateSnapshot: function (snapshot) {
      this.currentSnapshot = snapshot
      setTimeout(() => {
        this.$router.go({
          path: this.$router.path,
          query: {
            t: +new Date(),
          },
        });
      }, 500);
    },
  },
  computed: {
    ...mapGetters(["getSnapshots"]),
    ...mapFields(["currentSnapshot"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";

::v-deep .dropdown-menu {
    max-height: 50vh;
    overflow-y: auto;
  }

b{
  color: $primary-color;
}
  
</style>
